/** @module The build this browser runs, for telemetry and feedback. */
export const APP_VERSION: string = __APP_VERSION__;
